import React from "react";
import "../styles/Hero.css";

function Hero() {
  return (
    <section className="hero" id="hero">
      <div className="hero-overlay">
        <div className="hero-content">
          {/* Columna izquierda */}
          <div className="hero-left" data-aos="fade-right">
            <ul className="hero-list">
              <li>
                <span className="plus-icon">+</span>
                 <span>
                  <strong>de 7 años de experiencia</strong> en <br/> el sector de innovación y <br/>suministros de agro-insumos.
                </span>
              </li>
              <li>
                <span className="check-icon">✔</span>
                <span className="highlight">  Soluciones orgánicas y convencionales.</span>
              </li>
              <li>
                <span className="check-icon">✔</span>
                <span>
                  <strong>Resultados comprobados</strong><br/> en cultivos.
                </span>
              </li>
            </ul>
            <button
              className="hero-cta"
              onClick={() =>
                document.getElementById("productos")?.scrollIntoView({ behavior: "smooth" })
              }
            >
              DESCUBRE NUESTRAS SOLUCIONES
            </button>
          </div>

          {/* Columna central con logo */}
          <div className="hero-badge-wrap" data-aos="zoom-in">
            <img
              src={require("../assets/images/Recurso 1.png")}
              alt="Biogrand - Nutrimos la vida"
              className="hero-badge"
            />
          </div>

          {/* Columna derecha */}
          <div className="hero-right" data-aos="fade-left">
             <p className="hero-sub">
              Orgánicos y convencionales  <br />para cultivos sostenibles, <br /> productivos y rentables.
            </p>
            <h1 className="hero-title">
              FERTILIZANTES QUE <br />NUTREN TUS CULTIVOS <br />Y EL FUTURO DEL CAMPO
            </h1>
          </div>
        </div>
      </div>

      {/* Beneficios debajo */}
      <div className="hero-benefits">
        <div className="benefit-card" data-aos="fade-up" data-aos-delay="100">
          <h3>Relación costo-beneficio</h3>
          <p>
            Nuestros productos y manejo integral del campo están diseñados para lograr resultados
            visibles, sostenibles y duraderos en el tiempo con mejoras de la salud del suelo.
          </p>
        </div>

        <div className="benefit-card" data-aos="fade-up" data-aos-delay="200">
          <h3>Acompañamiento técnico</h3>
          <p>
            Brindamos asesoría técnica desde la siembra hasta la cosecha, con respaldo de ingenieros
            agrónomos que conocen el terreno y las necesidades reales del productor.
          </p>
        </div>

        <div className="benefit-card" data-aos="fade-up" data-aos-delay="300">
          <h3>Sostenibilidad aplicada al campo</h3>
          <p>
            Nuestros fertilizantes orgánico-minerales y convencionales están diseñados para nutrir
            el suelo y fertilizar la planta, apostando a un futuro más sano para el campo.
          </p>
        </div>
      </div>
    </section>
  );
}

export default Hero;
